const routes = [
  // 授权学员管理
  {
    path: "/aiForeign",
    name: "aiForeign",
    meta: {
      title: 'AI外教',
      hasBack: false
    },
    component: () => import("../pages/aiForeign/index.vue")
  },
];

export default routes;
